<template>
    <kt-panel>
        <kt-panel-header>
            <kt-panel-header-toolbar>
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#single-request" role="tab" aria-selected="false">
                            {{ $t('money_request.single_request') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#gregarious-request" role="tab" aria-selected="false">
                            {{ $t('money_request.gregarious_request') }}
                        </a>
                    </li>
                </ul>
            </kt-panel-header-toolbar>
        </kt-panel-header>
        <div class="tab-content">
            <div class="tab-pane active" id="single-request">
                <form @submit.prevent="submitSingleRequest($event, query)"
                      id="single-request-form"
                      class="kt-form p-3 my-4"
                >
                    <kt-form-section>
                        <kt-row>
                            <kt-col lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="full_name">
                                        {{ $t('money_request.full_name') }}
                                    </kt-form-label>
                                    <kt-form-control id="full_name" name="full_name" v-model="query.full_name">
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="phone">
                                        {{ $t('money_request.phone') }}
                                    </kt-form-label>
                                    <kt-form-control id="phone" name="phone" v-model="query.phone">
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                        <kt-row>
                            <kt-col lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="amount">
                                        {{ $t('money_request.amount') }}
                                    </kt-form-label>
                                    <currency-input
                                        dir="rtl"
                                        :currency="{
                                                suffix: '',
                                                prefix: ''
                                            }"
                                        v-model="query.amount"
                                        :precision="0"
                                        :value-range="{min:10000}"
                                        :value-as-integer="true"
                                        :allow-negative="false"
                                        id="amount"
                                        name="amount"
                                        class="form-input form-control"
                                        :placeholder="$t('pardakht_shakhsi.form.placeholder.rial_amount')"
                                    >
                                    </currency-input>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="description">
                                        {{ $t('money_request.description') }}
                                    </kt-form-label>
                                    <kt-form-textarea id="description" name="description" v-model="query.description">
                                    </kt-form-textarea>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                    </kt-form-section>
                    <kt-form-action>
                        <kt-button
                        id="form-btn"
                        class="btn btn-success btn-wide"
                        type="submit"
                        variant="success"
                        >
                            {{ $t('money_request.submit') }}
                        </kt-button>
                    </kt-form-action>
                </form>
            </div>
            <div class="tab-pane" id="gregarious-request">
                <form @submit.prevent="submitGroupRequest($event, query)"
                      id="gregarious-request-form"
                      class="kt-form p-3 my-4"
                >
                    <kt-form-section>
                        <kt-row>
                            <kt-col lg="12" md="12" xs="12" style="margin: 0 auto; text-align: center">
                                <kt-form-group>
                                    <kt-form-label for="file"
                                                   class="d-block btn btn-secondary btn-wide label-file"
                                                   style="margin: 0 auto"
                                    >
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('money_request.select_file') }}
                                    </kt-form-label>
                                    <input
                                        @change="processExcelFile"
                                        type="file"
                                        class="custom-file-upload"
                                        name="file"
                                        id="file"
                                        accept=".xlsx"
                                    />
                                    <ul class="list-group mb-3 mt-3">
                                        <li class="border-0 px-0 py-1 list-group-item">
                                            <strong>
                                                {{ $t('money_request.file_hint') }}
                                            </strong>
                                            <a :href="excelTemplateLink()">
                                                <strong>
                                                    {{ $t('money_request.file_hint_second') }}
                                                </strong>
                                            </a>
                                            <strong>
                                                {{$t('money_request.file_hint_third') }}
                                            </strong>
                                        </li>
                                    </ul>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                    </kt-form-section>
                    <kt-form-action style="text-align: center">
                        <kt-button
                            id="excel-form-btn"
                            class="btn btn-success btn-wide"
                            type="submit"
                            variant="success"
                        >
                            {{ $t('money_request.submit') }}
                        </kt-button>
                    </kt-form-action>
                </form>
                <ul class="list-group mb-3 ml-5" >
                    <li class="border-0 px-0 py-1 list-group-item">{{ $t('money_request.hint.hint') }}</li>
                    <li class="border-0 px-0 py-1 list-group-item">{{'- ' + $t('money_request.hint.first') }}</li>
                    <li class="border-0 px-0 py-1 list-group-item">{{'- ' + $t('money_request.hint.second') }}</li>
                    <li class="border-0 px-0 py-1 list-group-item">{{'- ' + $t('money_request.hint.third') }}</li>
                </ul>
            </div>
        </div>
    </kt-panel>
</template>

<script>

import {i18n} from "@/plugins/i18n";
import $ from "jquery";
import { BASE_PATH } from '@/common/config'

export default {
    props: {
        submitSingleRequest: {
            default: function($event, query) {},
            type: Function
        },
        submitGroupRequest: {
            default: function($event, query) {},
            type: Function
        },
    },
    data() {
        return {
            active_pane: '#single-request',
            query: {}
        }
    },
    methods: {
        processExcelFile(e) {
            this.query.file = event.target.files[0]
            this.validateSize(event.target)
            this.validateFormat(event.target)
        },
        validateSize(file) {
            var FileSize = file.files[0].size / 1024 / 1024; // in MB
            if (FileSize > 1) {
                alert(i18n.t('money_request.file_size_hint'));
                $(file).val('');
            } else {

            }
        },
        validateFormat(file) {
            let jq_file = $(file);
            let file_name = jq_file.val();
            let extension = file_name.replace(/^.*\./, '');
            if (extension === file_name) {
                extension = '';
            } else {
                extension = extension.toLowerCase();
            }

            switch (extension) {
                case 'xlsx':
                    break;
                default:
                    alert(i18n.t('authenticate.input_format_err'));
                    $(file).val('');
            }
        },
        excelTemplateLink() {
            return BASE_PATH + '/money-request/download'
        }
    }
}
</script>